import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider as JotaiProvider } from "jotai";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoginProvider } from "./context/login-context";
import { ReactGAProvider } from './context/react-ga';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
//import { ThemeProvider } from "@mui/material";

// import { light as lightTheme } from './layouts/default'
// import { theme } from "./emotion/utils";

import Protected from './layouts/protected';

import ErrorBoundary from "./components/error-boundary/error-boundary";
import MainLayout from "./components/main-layout/main-layout";

import { AccountDetails, Accounts, FarmDetails, Home, Login, NotFound, Reports, ResetPassword, StatementBuilder, Statements, ValleyUsers } from "./pages";
import { UsersBlock } from "./pages/account-details/blocks";
import Dealers from "./pages/dealers/dealers";
import DealerDetails from "./pages/dealer-details/dealer-details";


function App() {
  const queryClient = new QueryClient();

  const routes = (
    <Routes>
      <Route element={<Protected />}>
        <Route path="/" element={<MainLayout />}>
          <Route exact path="/" element={<Home />} />
          <Route path="/reports" element={<Reports />} />

          <Route element={<Protected allowedRoles={['SUPER_ADMIN', 'VALMONT_FINANCE', 'VALMONT_REP', 'STRATEGIC_ACCOUNT']} />}>
            <Route path="/statements" element={<Statements />} />
            <Route path="/statements/build" element={<StatementBuilder />} />
          </Route>

          <Route element={<Protected allowedRoles={['SUPER_ADMIN', 'VALMONT_FINANCE', 'VALMONT_REP', 'SUB_ENTITY']} />}>
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/account/:accountName" element={<AccountDetails accountType={"STRATEGIC_ACCOUNT"} />} />
            <Route path="/valley-users" element={<ValleyUsers />} />
            <Route path="/dealers" element={<Dealers />} />
            <Route path="/dealer/:dealerName" element={<DealerDetails />} />
            <Route path="/sub-account" element={<AccountDetails accountType={"SUB_ENTITY"} />} />
           
          </Route>

          <Route element={<Protected allowedRoles={['STRATEGIC_ACCOUNT']} />}>
            <Route path="/account" element={<AccountDetails accountType={"STRATEGIC_ACCOUNT"} />} />
          </Route>

          <Route element={<Protected allowedRoles={['FARM']} />}>
            <Route path="/farm" element={<FarmDetails />} />
          </Route>

          <Route element={<Protected allowedRoles={['SUB_ENTITY', 'STRATEGIC_ACCOUNT', 'SUPER_ADMIN', 'VALMONT_FINANCE', 'VALMONT_REP']} />}>
          <Route path="/sub-account/:accountName" element={<AccountDetails accountType={"SUB_ENTITY"} />} />
          </Route>

          <Route element={<Protected allowedRoles={['STRATEGIC_ACCOUNT', 'SUPER_ADMIN', 'VALMONT_FINANCE', 'VALMONT_REP']} />}>
            <Route path="/farm/:farmName" element={<FarmDetails />} />
          </Route>


        </Route>
      </Route>

      <Route exact path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );

  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <LoginProvider>
          <ReactGAProvider>
            <JotaiProvider>
              <QueryClientProvider client={queryClient}>
                {/* <ThemeProvider theme={lightTheme}></ThemeProvider> */}
                <BrowserRouter>
                  {routes}
                </BrowserRouter>{" "}
              </QueryClientProvider>
            </JotaiProvider>
          </ReactGAProvider>
        </LoginProvider>
      </LocalizationProvider>
    </ErrorBoundary>
  );
}

export default App;
